export default "__VITE_ASSET__OZKIPq2C__"